import { createContext, useEffect, use, useRef } from "react"
import { Toaster, ToasterHandle } from "@cividao/components"
import { useLocalStorage } from "../../hooks/useLocalStorage"
import { LayoutContextInterface, LayoutProviderProps, THEME_MODE_STORAGE_KEY, ThemeMode } from "./types"

const initialState: LayoutContextInterface = {
  themeMode: ThemeMode.LIGHT,
  setThemeMode: () => {},
}

const Context = createContext<LayoutContextInterface>(initialState)

export const LayoutContext = ({ children }: LayoutProviderProps) => {
  const [themeMode, setThemeMode] = useLocalStorage<ThemeMode>(THEME_MODE_STORAGE_KEY, ThemeMode.LIGHT)
  const toasterRef = useRef<ToasterHandle>(null)

  useEffect(() => {
    const rootElement = document.getElementById("root")
    if (rootElement) {
      rootElement.classList.remove(ThemeMode.LIGHT, ThemeMode.DARK)
      rootElement.classList.add(themeMode)
    }
  }, [themeMode])

  return (
    <Context.Provider
      value={{
        themeMode,
        setThemeMode,
      }}
    >
      <Toaster ref={toasterRef} />
      {children}
    </Context.Provider>
  )
}

export const useLayout = function () {
  const context = use(Context)
  if (context === undefined) {
    throw new Error(`useLayout must be used within a LayoutContextProvider`)
  }
  return context
}

export { type LayoutContextInterface, type LayoutProviderProps, ThemeMode }
